import { ApiError, ApiValidationError, RequestError } from "types/Api";

export const isRequestError = (err: unknown): err is RequestError => err instanceof Error;
export const isValidationError = (err: unknown): err is ApiValidationError =>
  typeof err === "object" &&
  err !== null &&
  "payload" in err &&
  typeof (err as any).payload === "object" &&
  (err as any).payload !== null &&
  "validationErrors" in (err as any).payload;
export const isApiError = (err: unknown): err is ApiError => err instanceof Error;